import {

  GET_DOMESTICBANK_SUCCESS,
  GET_DOMESTICBANKS_BY_USERNAME,
  GET_DOMESTICBANKS_BY_USERNAME_SUCCESS,
  DOMESTICBANK_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [], //Model Data ve Error
  error: {},
}

const domesticBankDefinition = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_DOMESTICBANK_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
      }

    case GET_DOMESTICBANKS_BY_USERNAME:
      return {
        ...state,
        loadingDomesticBankListByPricingTableGuid: true,
      }

    case GET_DOMESTICBANKS_BY_USERNAME_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
        loadingDomesticBankListByPricingTableGuid: false,
      }

    case DOMESTICBANK_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loadingDomesticBankListByPricingTableGuid:false
      }

    default:

      return state

  }
}

export default domesticBankDefinition